//src/context/AuthContext.js
 
import React, { createContext, useState, useEffect, useContext } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { limpiarStorageSensibleAlSalir } from '../utils/limpiarSesion';
import { auth, db } from '../services/firebase';
import { collection, getDocs, query, where, doc, onSnapshot } from 'firebase/firestore';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        // Cargar datos adicionales del usuario desde Firestore
        try {
          const usuariosQuery = query(
            collection(db, 'usuarios'), 
            where('email', '==', firebaseUser.email)
          );
          const usuariosSnapshot = await getDocs(usuariosQuery);
          
          if (!usuariosSnapshot.empty) {
            const usuarioDoc = usuariosSnapshot.docs[0];
            const usuarioData = usuarioDoc.data();
            
            setUser({
              uid: firebaseUser.uid,
              email: firebaseUser.email,
              id: usuarioDoc.id,
              ...usuarioData
            });
          } else {
            setUser({
              uid: firebaseUser.uid,
              email: firebaseUser.email
            });
          }
        } catch (error) {
          console.error('Error cargando datos del usuario:', error);
          setUser({
            uid: firebaseUser.uid,
            email: firebaseUser.email
          });
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Seguridad (jun 2026): si el usuario es inactivado mientras tiene la sesión
  // abierta, cerrarla al instante. La protección dura la hace el servidor
  // (CF actualizarEstadoUsuarioAdmin: cuenta deshabilitada + tokens revocados);
  // esto es la salida inmediata en la pantalla. El uid solo cambia al iniciar
  // o cerrar sesión, así que el listener se crea una sola vez por sesión.
  useEffect(() => {
    if (!user?.uid) return;
    const unsubEstado = onSnapshot(
      doc(db, 'usuarios', user.uid),
      (snap) => {
        if (snap.exists() && snap.data().activo === false) {
          limpiarStorageSensibleAlSalir(); // A5: limpiar datos sensibles también al cierre involuntario
          signOut(auth).catch((e) => console.error('Error cerrando sesión de usuario inactivo:', e));
        }
      },
      (error) => {
        // Si el listener falla (reglas, red), no hacer nada acá: el cierre
        // lo garantiza igual el servidor (token revocado, muere en ≤1 hora).
        console.error('Listener de estado del usuario:', error);
      }
    );
    return () => unsubEstado();
  }, [user?.uid]);

  const value = {
    user,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}